var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-tabs-header f-row-ac"},_vm._l((_vm.items),function(item){return _c('div',{key:item.key,staticClass:"tab",class:{active: _vm.value === item.key},style:(_vm.colorVars),attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('input', item.key)}}},[_c('span',{domProps:{"textContent":_vm._s(item.label)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }